export enum RepresentativeEnum {
  enterprise,
  associacion,
}
const WebScraperAPI = {
  baseURL: "https://api.just-blink.pl",
  //baseURL: "http://localhost:3003",

  getRepresentatives: (id: string, type: string): Promise<Response> => {
    // eslint-disable-next-line no-undef
    const token = localStorage.getItem("token");

    // eslint-disable-next-line no-undef
    return fetch(`${WebScraperAPI.baseURL}/web-scraper/${id}?${new URLSearchParams({ type: type.toString() })}`, {
      headers: {
        Accept: "application/json; charset=utf-8",
        Authorization: `Bearer ${token}`,
      },
      method: "GET",
    }).then((response) => {
      if (!response.ok) {
        // Reject the promise with an error object containing the status and statusText
        return response
          .json()
          .then((t) => {
            return Promise.reject({
              status: response.status,
              statusText: response.statusText,
              code: t.code,
              message: t.message,
            });
          })
          .catch();
      }
      return response;
    });
  },
  getActualCopy: (id: string, type: string): Promise<Response> => {
    // eslint-disable-next-line no-undef
    const token = localStorage.getItem("token");

    // eslint-disable-next-line no-undef
    return fetch(`${WebScraperAPI.baseURL}/web-scraper/${id}/pdf?${new URLSearchParams({ type: type.toString() })}`, {
      headers: {
        Accept: "application/json; charset=utf-8",
        Authorization: `Bearer ${token}`,
      },
      method: "GET",
    }).then((response) => {
      if (!response.ok) {
        // Reject the promise with an error object containing the status and statusText
        return response
          .json()
          .then((t) => {
            return Promise.reject({
              status: response.status,
              statusText: response.statusText,
              code: t.code,
              message: t.message,
            });
          })
          .catch();
      }
      return response;
    });
  },
};

export default WebScraperAPI;
